const PROVIDER_LABELS = {
  hairchitech: 'Hairchitech AI',
  gemini: 'Gemini',
};

const PROVIDER_BADGE_CLASSES = {
  hairchitech: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  gemini: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
};

export const normalizeAiProvider = (provider) => {
  const normalized = typeof provider === 'string' ? provider.trim().toLowerCase() : '';
  return PROVIDER_LABELS[normalized] ? normalized : 'hairchitech';
};

export const formatAiProviderLabel = (provider) => PROVIDER_LABELS[normalizeAiProvider(provider)];

export const getAiProviderBadgeClass = (provider) =>
  PROVIDER_BADGE_CLASSES[normalizeAiProvider(provider)] || 'bg-gray-100 text-gray-800';
